module.exports = __webpack_public_path__ + "static/about-img-08fbf8c1edb0d56f0a119ea2bcb5347d.jpg";